import { ZoomableView } from './ZoomableView';

export default ZoomableView;
